module.exports = "/assets/5d39b87ffa2e0c5f42bf125d46587177.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-item-taxi/assets/taxi.png
// module id = 3442
// module chunks = 0